module.exports = __webpack_public_path__ + "img/car_shina2_10.be0f94d0.jpg";